import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoWardrobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2_24044)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0388 0H10.0007H3.96259C2.92259 0 2.07617 0.848302 2.07617 1.89057V16.9774C2.07617 18.0196 2.92259 18.8679 3.96259 18.8679L3.96296 20H4.71768V18.8679H10.0007H15.2837V20H16.0384V18.8679C17.0784 18.8679 17.9252 18.0196 17.9252 16.9774V1.89057C17.9252 0.848302 17.0788 0 16.0388 0ZM3.96259 17.9527C3.33806 17.9527 3 17.6038 3 16.9774V1.89057C3 1.26415 3.33844 0.955857 3.96259 0.955857H9.62334V17.9527H4.71768H3.96259ZM17.0182 16.9774C17.0182 17.6038 16.6626 17.9527 16.0384 17.9527H15.2837H10.3781V0.955857H16.0388C16.663 0.955857 17.0182 1.26415 17.0182 1.89057V16.9774Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86604 7.9248H8.11133V10.5663H8.86604V7.9248Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8875 7.92432H11.1328V10.5658H11.8875V7.92432Z",
				fill: "#9095B5"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2_24044",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgIcoWardrobe;
